exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "buy-product .centerErrorMessage{margin:auto;width:50%;margin-bottom:3px}buy-product .centerErrorMessage>p{text-align:center!important}buy-product .formGroup{margin-top:1em!important}buy-product .centerErrorMessage .errorMessage{display:block}.error p.error{padding:1.5em 15%!important}.error p.error span{padding:initial!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./src/app/pages/manage-purchase/my-purchase/buy-product/buy-product.styl
// module id = 923
// module chunks = 0